import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';

export class ClientAppConfig {
  registrationUrl: string;
  forgotUserNameUrl: string;
  hpUrl: string;
  technicalSupportPhone: string;
  generalenquiriesPhone: string;
  safescriptInfo: string;
  hpTraining: string;
  supportUrl: string;
  accessibilityUrl: string;
  copyrightUrl: string;
  disclaimerUrl: string;
  privacyUrl: string;
  twitter: string;
  maintenance: string;
  publicApi: string;
  patientUrl: string;
  contactUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  getAppConfig$: Observable<ClientAppConfig>;
  public version: string;
  constructor(private httpClient: HttpClient) { }

  init(version: string) {
    this.version = version;
  }

  appendVersionToUrl(url: string): string {
    url = `${url}?t=${this.version}`;
    return url;
  }

  getConfiguration() {
    if (!this.getAppConfig$) {
      const rootConfig = this.appendVersionToUrl('appconfig.json');
      this.getAppConfig$ = this.httpClient.get<ClientAppConfig>(rootConfig).pipe(share());
    }
    return this.getAppConfig$;
  }
}
